import i18next from 'i18next';
import { getLocalePrefix } from "../../i18n";
import template from './template';
import selectors from './constants/selectors';
import User from '../../modules/user';
import Configuration from '../../modules/configuration';
import prepareFadeIn from '../../utils/fade-in';
import parseElementFromString from '../../utils/parse-element-from-string';
import removeElementById from '../../utils/remove-element-by-id';
import hasPageStaticHeader from '../../utils/has-page-static-header';

function initialize() {
  if (hasPageStaticHeader()) {
    const user = User.get();
    const config = Configuration.get();
    const primaryButton = document.querySelector(selectors.HEADER_PRIMARY_BUTTON);
    const secondaryButton = document.querySelector(selectors.HEADER_SECONDARY_BUTTON);
    const localePrefix = getLocalePrefix();

    if (user.isAuthenticated()) {
      const data = [
        {
          title: i18next.t('Dashboard'),
          href: config.getDashboardUrl(),
        },
        {
          title: i18next.t('Log out'),
          href: config.getLogoutUrl(),
        }
      ];

      const languageSelector = document.querySelector(selectors.HEADER_LANGUAGE_SELECTOR);
      const container = languageSelector.parentElement;
      const profile = parseElementFromString(template(data));
      const dynamicContainer = document.createElement('div');

      dynamicContainer.classList.add('cms-dynamic-container');
      dynamicContainer.append(languageSelector, profile);

      const showProfileAnimation = prepareFadeIn(profile);

      container.append(dynamicContainer);

      languageSelector.addEventListener('click', () => {
        profile.hideContent();
      });

      primaryButton.remove();
      showProfileAnimation.run();
    } else {
      const primaryButtonLink = primaryButton.querySelector('a');

      if (primaryButtonLink) {
        primaryButtonLink.setAttribute('href', config.getLoginUrl({ prefix: localePrefix }));
      }

      secondaryButton.querySelector('a').setAttribute('href', config.getSignupUrl({ prefix: localePrefix }));

      const fadeInAnimation = prepareFadeIn(primaryButton);

      removeElementById('cms-i-login-button');
      fadeInAnimation.run();
    }
  }

}

export default initialize;
